<div class="dual-modal-backdrop"></div>
<div class="dual-modal">
  <div class="dual-modal-header">
    <h5>Ai Editor</h5>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>


  </div>

  <div class="row">
    <div class="col">
      <div class="controls">
        <button type="button" (click)="applyToPreview(0)" class="btn-sm">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7756 5.77566L16.4308 3.81026H17.5692L18.2243 5.77566L20.1897 6.43079V7.56921L18.2243 8.22434L17.5692 10.1897H16.4308L15.7756 8.22434L13.8102 7.56921V6.43079L15.7756 5.77566Z"
              fill="black" />
            <path d="M18 12V19H16V12H18Z" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.33728 6H10.6627L14.0329 19H11.9668L11.1891 16H6.81082L6.03304 19H3.96692L7.33728 6ZM7.32934 14H10.6706L9.11505 8H8.88489L7.32934 14Z"
              fill="black" />
          </svg>
          Chính tả | Spelling
        </button>
        <button type="button" (click)="applyToPreview(1)" class="btn-sm">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7756 5.77566L16.4308 3.81026H17.5692L18.2243 5.77566L20.1897 6.43079V7.56921L18.2243 8.22434L17.5692 10.1897H16.4308L15.7756 8.22434L13.8102 7.56921V6.43079L15.7756 5.77566Z"
              fill="black" />
            <path d="M18 12V19H16V12H18Z" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.33728 6H10.6627L14.0329 19H11.9668L11.1891 16H6.81082L6.03304 19H3.96692L7.33728 6ZM7.32934 14H10.6706L9.11505 8H8.88489L7.32934 14Z"
              fill="black" />
          </svg>
          Sửa nội dung | Content Editing
        </button>
        <button type="button" (click)="applyToPreview(2)" class="btn-sm">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7756 5.77566L16.4308 3.81026H17.5692L18.2243 5.77566L20.1897 6.43079V7.56921L18.2243 8.22434L17.5692 10.1897H16.4308L15.7756 8.22434L13.8102 7.56921V6.43079L15.7756 5.77566Z"
              fill="black" />
            <path d="M18 12V19H16V12H18Z" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.33728 6H10.6627L14.0329 19H11.9668L11.1891 16H6.81082L6.03304 19H3.96692L7.33728 6ZM7.32934 14H10.6706L9.11505 8H8.88489L7.32934 14Z"
              fill="black" />
          </svg>
          Viết lại bài | Refresh Content
        </button>
        <button type="button" (click)="applyToPreview(3)" class="btn-sm">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.7756 5.77566L16.4308 3.81026H17.5692L18.2243 5.77566L20.1897 6.43079V7.56921L18.2243 8.22434L17.5692 10.1897H16.4308L15.7756 8.22434L13.8102 7.56921V6.43079L15.7756 5.77566Z"
              fill="black" />
            <path d="M18 12V19H16V12H18Z" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.33728 6H10.6627L14.0329 19H11.9668L11.1891 16H6.81082L6.03304 19H3.96692L7.33728 6ZM7.32934 14H10.6706L9.11505 8H8.88489L7.32934 14Z"
              fill="black" />
          </svg>
          Tổng hợp nội dung | Content Summary
        </button>
      </div>
    </div>
  </div>
  <div class="dual-modal-body">


    <div class="pane">
      <div class="pane-title">Nội dung gốc -></div>
      <ckeditor #leftCk [editor]="Editor" [config]="config" [data]="leftData"
        (change)="onChange($event)"></ckeditor>

    </div>

    <div class="pane">
      <div class="pane-title">Nội dung hiệu chỉnh (WYSIWYG)</div>
      <ckeditor #rightCk [editor]="Editor" [config]="config" [data]="rightData"
        (change)="onChange($event)"></ckeditor>
    </div>


  </div>


  <div class="dual-modal-footer">
    <button (click)="doSave()" class="btn-primary">Lưu</button>
    <button (click)="close()" class="btn-secondary">Đóng</button>
  </div>
  
  <div class="ai-modal-loading" *ngIf="loading" role="status" aria-live="polite">
    <div class="ai-modal-loading__box">
      <div class="ai-modal-spinner" aria-hidden="true"></div>
      <div class="ai-modal-loading__text">{{ loadingStatus }}<span class="dots"></span></div>
    </div>
  </div>
</div>

